/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, {useState, useRef, useLayoutEffect, Fragment} from "react";
import {NavLink} from "reactstrap";
import PropTypes from "prop-types";
import {MdOutlineKeyboardArrowLeft, MdOutlineKeyboardArrowRight} from "react-icons/md";
import classnames from "classnames";
import "./style.scss";

const THRESHOLD = 2;

function TabsHeader({list, handleClick, activeTab}) {
  const tabsRef = useRef(null);

  const [scrollState, setScrollState] = useState({
    showScroll: false,
    atStart: true,
    atEnd: false,
  });

  const updateScrollState = () => {
    const el = tabsRef.current;
    if (!el) return;

    const {scrollLeft, scrollWidth, offsetWidth} = el;

    setScrollState({
      showScroll: scrollWidth > offsetWidth,
      atStart: scrollLeft <= THRESHOLD,
      atEnd: scrollWidth - offsetWidth - scrollLeft <= THRESHOLD,
    });
  };

  useLayoutEffect(() => {
    const el = tabsRef.current;
    if (!el) return;

    updateScrollState();

    const handleScroll = () => updateScrollState();
    const handleResize = () => updateScrollState();

    el.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleResize);

    return () => {
      el.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, [list]);

  const scrollByAmount = (direction) => {
    const el = tabsRef.current;
    if (!el) return;

    const amount = el.offsetWidth / 4;

    el.scrollBy({
      left: direction === "right" ? amount : -amount,
      behavior: "smooth",
    });
  };

  return (
    <Fragment>
      <div className="position-relative">
        {scrollState.showScroll && (
          <Fragment>
            {!scrollState.atStart && (
              <div
                className="d-flex align-items-center cursor-pointer scroll-left-container"
                data-cy={"scroll-left-button"}
                onClick={() => scrollByAmount("left")}
              >
                <MdOutlineKeyboardArrowLeft style={{fontSize: "30px"}} />
              </div>
            )}

            {!scrollState.atEnd && (
              <div
                className="d-flex align-items-center cursor-pointer scroll-right-container"
                data-cy={"scroll-right-button"}
                onClick={() => scrollByAmount("right")}
              >
                <MdOutlineKeyboardArrowRight style={{fontSize: "30px"}} />
              </div>
            )}
          </Fragment>
        )}

        <div className="zeus-tabs" ref={tabsRef}>
          {list?.map((tab, index) => (
            <div key={`${tab.key}_${index}`} style={{minWidth: "25%"}}>
              <NavLink
                className={classnames("roboto-bold", {
                  active: activeTab === tab.key,
                })}
                data-cy={`cy_${tab.name}`}
                onClick={() => handleClick(tab.key)}
                style={{textAlign: "center"}}
              >
                {tab.name}
              </NavLink>
            </div>
          ))}
        </div>
      </div>
    </Fragment>
  );
}

export default TabsHeader;

TabsHeader.propTypes = {
  list: PropTypes.array,
  handleClick: PropTypes.func,
  activeTab: PropTypes.string,
};
